import React from 'react';
import SelectComponent from "../../select/select-component.jsx";
import useFetchOptions from "./hooks/use-fetch-options.js";

const AccessForm = ({filters, setFilters, customTitle, hasLoginInput = true, hasNameWarInput = false, isMulti = true,
                     customUserNameOptions = null, customUserNameWarOptions = null, customUserLoginOptions = null, customUserCpfOptions = null,
                     valueAsId = false, filterInputs = {}}) => {

    const { userNameOptions, userLoginOptions, userCpfOptions, userNameWarOptions } = useFetchOptions(valueAsId);

    const inputs = {
        login: filterInputs.login ?? "userLogin",
        name: filterInputs.name ?? "userName",
        cpf: filterInputs.cpf ?? "userCpf",
        nameWar: filterInputs.nameWar ?? "userNameWar",
    };

    const hasLogin = isMulti ? (filters[inputs.login]?.length ?? 0) > 0 : filters[inputs.login];
    const hasName = isMulti ? (filters[inputs.name]?.length ?? 0) > 0 : filters[inputs.name];
    const hasCpf = isMulti ? (filters[inputs.cpf]?.length ?? 0) > 0 : filters[inputs.cpf];
    const hasNameWar = isMulti ? (filters[inputs.nameWar]?.length ?? 0) > 0 : filters[inputs.nameWar];

    const disabledLogin = hasName || hasCpf || hasNameWar;
    const disabledName = hasLogin || hasCpf || hasNameWar;
    const disabledCpf = hasLogin || hasName || hasNameWar;
    const disabledNameWar = hasLogin || hasCpf || hasName;

    const normalizeCpf = (value = "") => String(value).replace(/\D/g, "");

    const cpfFilterOption = (option, inputValue) => {
        const label = option?.label || option?.data?.label || "";
        const value = option?.value || option?.data?.value;

        const options = customUserCpfOptions ?? userCpfOptions;
        const normalizedInput = normalizeCpf(inputValue);

        if (value === "*") {
            return options.some(opt =>
                normalizeCpf(opt.label).startsWith(normalizedInput)
            );
        }

        const normalizedLabel = normalizeCpf(label);
        if (!normalizedInput) return true;
        return normalizedLabel.startsWith(normalizedInput);
    };

    return (
        <>
            <div className="separator mb-3"> {customTitle ?? 'Acesso'} </div>

            { hasLoginInput && (
                <SelectComponent
                    label="Login"
                    isMulti={isMulti}
                    wrapValues
                    options={customUserLoginOptions ?? userLoginOptions}
                    value={filters[inputs.login]}
                    onChange={(value) => setFilters(prev => ({...prev, [inputs.login]: value}))}
                    classNameWrapper="w-full"
                    isDisabled={disabledLogin}
                />
            )}

            { hasNameWarInput && (
                <SelectComponent
                    label="Nome de guerra"
                    isMulti={isMulti}
                    wrapValues
                    options={customUserNameWarOptions ?? userNameWarOptions}
                    value={filters[inputs.nameWar]}
                    onChange={(value) => setFilters(prev => ({...prev, [inputs.nameWar]: value}))}
                    classNameWrapper="w-full"
                    isDisabled={disabledNameWar}
                />
            )}

            <SelectComponent
                label="Nome"
                isMulti={isMulti}
                wrapValues
                options={customUserNameOptions ?? userNameOptions}
                value={filters[inputs.name]}
                onChange={(value) => setFilters(prev => ({...prev, [inputs.name]: value}))}
                classNameWrapper="w-full"
                isDisabled={disabledName}
            />

            <SelectComponent
                label="CPF"
                isMulti={isMulti}
                wrapValues
                options={customUserCpfOptions ?? userCpfOptions}
                value={filters[inputs.cpf]}
                onChange={(value) => setFilters(prev => ({...prev, [inputs.cpf]: value}))}
                classNameWrapper="w-full"
                isDisabled={disabledCpf}
                cpfFilter
                filterOption={cpfFilterOption}
            />
        </>
    );
};

export default AccessForm;